import { Base } from "ui/Scripts/source/framework/base";
import { EnumHelper, EventUserState, RecordEmployeeType } from "ui/Scripts/source/models/enums";
import { IRecordListItemUserFurtherEducation, RecordListItemUserFurtherEducation } from "ui/Scripts/source/models/recordUserFurtherEducation/recordListItemUserFurtherEducation";
import { IRecordListItemUserFamiliarization, RecordListItemUserFamiliarization } from "ui/Scripts/source/models/recordUserFamiliarization//recordListItemUserFamiliarization";
import { IRecordListItemUserQualification, RecordListItemUserQualification } from "ui/Scripts/source/models/recordUserQualification/recordListItemUserQualification";
import { IUserListItemUserGroup, UserListItemUserGroup } from "../user/userListItemUserGroup";

export interface IRecordListItem {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    picture: string;
    email: string;
    phone: string;
    birthDate: number;
    employeeType: RecordEmployeeType;
    employeeTypeStr: string;
    archived: boolean;
    basicEducationName: string;
    unitCode: string;
    userCode: string;
    userCompanyId: string;
    userEndDate: number;
    userDisabled: boolean;
    sharedByCompanyName: string;
    sharedToCompanies: string[];
    userGroups: IUserListItemUserGroup[];
    familiarizations: IRecordListItemUserFamiliarization[];
    furtherEducations: IRecordListItemUserFurtherEducation[];
    qualifications: IRecordListItemUserQualification[];

    getName(): string;
    hasQualifications(): boolean;
    allQualificationsOk(): boolean;
    getQualificationsForUi(): string[];
    hasUnApprovedFamiliarizations(): boolean;
}

export class RecordListItem implements IRecordListItem {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    picture: string;
    email: string;
    phone: string;
    birthDate: number;
    employeeType: RecordEmployeeType;
    employeeTypeStr: string;
    archived: boolean;
    basicEducationName: string;
    unitCode: string;
    userCode: string;
    userCompanyId: string;
    userEndDate: number;
    userDisabled: boolean;
    sharedByCompanyName: string;
    sharedToCompanies: string[];
    userGroups: UserListItemUserGroup[];
    familiarizations: RecordListItemUserFamiliarization[];
    furtherEducations: RecordListItemUserFurtherEducation[];
    qualifications: RecordListItemUserQualification[];

    constructor();
    constructor(obj: IRecordListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.firstName = obj && obj.firstName || "";
        this.middleName = obj && obj.middleName || "";
        this.lastName = obj && obj.lastName || "";
        this.picture = obj && obj.picture || "";
        this.email = obj && obj.email || "";
        this.phone = obj && obj.phone || "";
        this.birthDate = obj && obj.birthDate || null;
        this.employeeType = obj && obj.employeeType || RecordEmployeeType.Employee;
        this.employeeTypeStr = EnumHelper.RecordEmployeeTypeToStr(this.employeeType);
        this.archived = obj && obj.archived || false;
        this.basicEducationName = obj && obj.basicEducationName || "";
        this.unitCode = obj && obj.unitCode || "";
        this.userCode = obj && obj.userCode || "";
        this.userCompanyId = obj && obj.userCompanyId || "";
        this.userEndDate = obj && obj.userEndDate || 0;
        this.userDisabled = obj && obj.userDisabled || false;
        this.sharedByCompanyName = obj && obj.sharedByCompanyName || "";
        this.sharedToCompanies = obj && obj.sharedToCompanies || [];
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UserListItemUserGroup);
        this.familiarizations = Base.getTypedArray(obj ? obj.familiarizations : null, RecordListItemUserFamiliarization);
        this.furtherEducations = Base.getTypedArray(obj ? obj.furtherEducations : null, RecordListItemUserFurtherEducation);
        this.qualifications = Base.getTypedArray(obj ? obj.qualifications : null, RecordListItemUserQualification);
    }

    getName(): string {
        return ((this.lastName ?? "") + " " + (this.firstName ?? "")).trim();
    }

    hasQualifications(): boolean {
        return this.qualifications.length > 0;
    }

    allQualificationsOk(): boolean {
        return !this.qualifications.filter(i => !i.valid).length;
    }

    getQualificationsForUi(): string[] {
        return this.qualifications.map(i => i.code + " (" + RecordListItemUserQualification.getQualificationState(i) + ")");
    }

    hasUnApprovedFamiliarizations(): boolean {
        return this.familiarizations.filter(i => i.userState === EventUserState.NotApproved).length > 0;
    }
}